export enum FileStatus {
  Pending = 0,
  Processed = 1,
  Failed = 2,
  Processing = 3,
  Queued = 4,
  Invalid = 5
}
